import {isTicketed} from '@wix/wix-events-commons-statics'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import React, {useEffect} from 'react'
import {DETAILS_ROUTE} from '../../../../../commons/constants/navigation'
import {useAppActions, useAppSelector} from '../../hooks/runtime'
import {getEvent} from '../../selectors/event'
import {getReservationState, getRoute} from '../../selectors/navigation'
import {FormEntry} from '../chunks/form-entry'
import {StatusScreensEntry} from '../chunks/status-screens-entry'
import {EventDetails} from '../event-details'
import {EventDetailsMobile} from '../event-details-mobile'

export const Router = () => {
  const {isMobile: mobile} = useEnvironment()

  const event = useAppSelector(getEvent)
  const route = useAppSelector(getRoute)
  const reservationState = useAppSelector(getReservationState)

  switch (route) {
    case DETAILS_ROUTE.DETAILS:
    case DETAILS_ROUTE.PICK_TICKETS:
      return mobile ? <EventDetailsMobile /> : <EventDetails />
    case DETAILS_ROUTE.TICKET_FORM:
    case DETAILS_ROUTE.FORM:
    case DETAILS_ROUTE.CHECKOUT:
      return <FormEntry route={route} ticketed={!!event && isTicketed(event)} />
    case DETAILS_ROUTE.TEMPLATE_ORDER:
    case DETAILS_ROUTE.ORDER:
    case DETAILS_ROUTE.ONLINE_CONFERENCING:
    case DETAILS_ROUTE.LINK_EXPIRED:
    case DETAILS_ROUTE.NOT_FOUND:
    case DETAILS_ROUTE.CHANGE_RSVP:
    case DETAILS_ROUTE.THANK_YOU_MESSAGES:
      return <StatusScreensEntry route={route} reservationState={reservationState} />
    default:
      return <NotFound />
  }
}

const NotFound = () => {
  const {detailsPageLoaded} = useAppActions()

  useEffect(() => {
    detailsPageLoaded()
  }, [])

  return <div>404</div>
}
